import { render } from "./uiFormError.vue?vue&type=template&id=54180970&scoped=true"
import script from "./uiFormError.vue?vue&type=script&lang=js"
export * from "./uiFormError.vue?vue&type=script&lang=js"

import "./uiFormError.vue?vue&type=style&index=0&id=54180970&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54180970"]])

export default __exports__